import React, { Component, lazy, Suspense } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import t from '../../localization';
import { connect } from 'react-redux';
import { actions as kandyActions } from 'kandy-redux';
import { bindActionCreators } from 'redux';
import {
    agentActions,
    dashboardActions,
    serviceRequestActions,
    agentProfileActions
} from '../../actions';
import { reportPreviewActions, lossAssDashboard, report } from '../../../client/lossAss/actions';
import { setLocalUser, getAgentUserType } from '../../utils/auth';
import StateTypes from '../../constants/StateTypes';
import { Dropdown, Popover, Menu, message, Modal, Form, Input, Button } from 'antd';

import TaskListModal from './TaskListModal.js';
import axios from 'axios';
import EventBus from '../../components/eventBus';
import logo from '../../assets/images/logo-main.png';
import defaultAvatar from '../../assets/images/avatar.png';
import { put } from '../../utils/http';
import { expressMaterialStat } from '@service/expressMaterial';
import './style.scss';

const Calling = lazy(() => import('../../components/5gCall/calling'))

const agentProfileTypes = StateTypes.app.agentProfile;

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: false,
            showProfileType: agentProfileTypes.basicInfo,
            isShowTaskListModal: false,
            aboutAgent: {},
            isShowMarquee: false,
            allValues: {},
            passwordVisible: false,
            expressMaterialStat: undefined
        };
    }
    passwordFormRef = React.createRef();

    componentDidMount() {
        const { currentAgent } = this.props;
        const _this = this;
        setLocalUser(localStorage['preSaveName'], localStorage['preSavePwd']);

        this.getCoopTaskAboutAgent();

        window.addEventListener('message', this.receiveMessage, false);
        EventBus.addListener('logout', function (url) {
            _this.props.history.replace(url);
        });

        EventBus.addListener('push', function (url) {
            _this.props.history.replace(url);
        });
        currentAgent?.userInfo?.permission?.includes('expressMaterial') &&
            this.getExpressMaterialStat();

       
    }
    getExpressMaterialStat = () => {
        expressMaterialStat().then(({ result }) => {
            this.setState({
                expressMaterialStat: result.total
            });
        });
    };
    componentWillUnmount() {
        EventBus.removeListener('logout');
        EventBus.removeListener('push');
    }
    receiveMessage = (event) => {
        const data = event.data;
        if (data.eventName === 'pushCoopTaskTipsToAgent') {
            this.setState({
                isShowMarquee: true
            });
            // 重新获取数据
            this.getCoopTaskAboutAgent();
            // this.TaskListModal.stateRefresh()
        }
        // 邮寄统计数量变更通知
        if (data.eventName === 'ExpressMaterialStatUpdate') {
            console.log('ExpressMaterialStatUpdate',data);
            this.setState({
                expressMaterialStat: data.total
            });
           
        }
    };

    handleLogout(event) {
        event.preventDefault();
        const { actions, currentAgent, customers, company } = this.props;
        if (getAgentUserType() == 10) {
            actions.agentLogout();
        } else {
            customers.map((customer) => {
                // actions.sendJSON(customer.userId, {'session': 'ended'});
                actions.sendMessage(customer.userId, '', {
                    additionalData: { type: 'control', session: 'ended' }
                });
                actions.endSession(customer.userId);
            });

            actions.agentLogout(company.id, currentAgent.userInfo.fullUserId);
        }
    }

    endCallAndLogout(e) {
        e.preventDefault();

        const { actions, customers, currentAgent, calls, company } = this.props;
        // End the call if it is ongoing for the current customer
        customers.map((customer, index) => {
            calls.map((c) => {
                actions.endKandyCall(customer.userId, c.callId);
                // actions.sendJSON(customer.userId, {'session': 'ended'});
                actions.sendMessage(customer.userId, '', {
                    additionalData: { type: 'control', session: 'ended' }
                });
                actions.endSession(customer.userId);
            });
        });
        actions.agentLogout(company.id, currentAgent.userInfo.fullUserId);
    }

    openDialog() {
        const { currentRequest, currentCustomerCount } = this.props;
        if ((currentRequest && currentRequest.length > 0) || currentCustomerCount > 0) {
            this.setState({ showDialog: false, isPromptShow: true });
        } else {
            this.setState({ showDialog: true });
        }
    }

    closeDialog() {
        this.setState({ showDialog: false });
    }

    changeProfileType() {
        this.setState({ showProfileType: agentProfileTypes.password });
    }

    handleMenuClick(e) {
        const { currentAgent } = this.props;
        if (currentAgent.agentServiceStatus && currentAgent.agentServiceStatus == e.key) {
            return false;
        }
        this.props.actions.setAgentServiceStatus(this.props.currentAgent.userInfo._id, e.key);
    }
    showTaskListModal = () => {
        this.setState({
            isShowTaskListModal: true
        });
        // this.TaskListModal.setQueryForHeader(this.props.currentAgent.userInfo._id)
    };
    hideTaskListModal = () => {
        this.setState({
            isShowTaskListModal: false,
            isShowMarquee: false
        });
    };
    // /api/lossAss/coopTask/aboutAgent
    getCoopTaskAboutAgent = () => {
        setTimeout(() => {
            const agentId = this.props.currentAgent.userInfo._id;
            if (!agentId) {
                return;
            }
            axios({
                method: 'get',
                url: `/api/lossAss/coopTask/aboutAgent`,
                params: {
                    agentId
                }
            })
                .then((res) => {
                    if (res.data.errCode === 0) {
                        this.setState({
                            aboutAgent: res.data.result
                        });
                    } else {
                        message.error(res.data.errInfo);
                    }
                })
                .catch((err) => {
                    message.error(err.message || '请求/api/lossAss/coopTask/aboutAgent失败');
                });
        }, 1000);
    };
    editPassword = () => {
        this.setState({
            passwordVisible: true
        });
    };
    handleEditPassword = () => {
        const { userInfo } = this.props;
        this.passwordFormRef.current.validateFields().then((values) => {
            const { newPassword, confirmPassword } = values;
            const reg = /^(?=.*?[0-9])(?=.*?[a-zA-Z])[0-9a-zA-Z]{8,}$/;
            if (!reg.test(newPassword)) {
                message.error('密码长度≥8位，须包含字母、数字');
                return;
            }
            if (newPassword !== confirmPassword) {
                message.error('新密码和确认密码必须一致');
                return;
            }
            put(`/api/agents/resetPwd/${userInfo.fullUserId}`, values)
                .then(() => {
                    message.success('修改成功');
                    this.setState({
                        passwordVisible: false
                    });
                })
                .catch((err) => {
                    message.error(err.message || '修改失败');
                });
        });
    };
    cancelEditPassword = () => {
        this.setState({
            passwordVisible: false
        });
    };

    render() {
        const { actions, calls, currentAgent, userInfo } = this.props;
        const { passwordVisible } = this.state;

        const statusList = (
            <Menu className="agent-status-menu" onClick={this.handleMenuClick.bind(this)}>
                <Menu.Item key="on" className="online-menu">
                    <span className="text">上班</span>
                </Menu.Item>
                <Menu.Item key="off" className="offline-menu">
                    <span className="text">下班</span>
                </Menu.Item>
            </Menu>
        );

        let agentStatus, labelAgentStatus;
        agentStatus = currentAgent.agentServiceStatus ? currentAgent.agentServiceStatus : 'off';
        switch (agentStatus) {
            case 'on':
                agentStatus = 'online';
                labelAgentStatus = '上班';
                break;
            case 'off':
                agentStatus = 'offline';
                labelAgentStatus = '下班';
                break;
        }

        if (currentAgent.userInfo.company) {
            document.title = currentAgent.userInfo.company.name + '在线客服';
        }
        const departments =
            userInfo.departments && userInfo.departments.length
                ? userInfo.departments.map((department) => department.name).join('、')
                : '';
        const profileModal = (
            <div className="agent-profile">
                <dl>
                    <dt>
                        <img src={userInfo.profilePic ? userInfo.profilePic : defaultAvatar} />
                        {userInfo.agentRole ? (
                            <span className="role">
                                {userInfo.agentRole.roleName ? userInfo.agentRole.roleName : ''}
                            </span>
                        ) : null}
                    </dt>
                    <dd>
                        <p>账号：{userInfo.loginName}</p>
                        <p>姓名：{userInfo.fullName}</p>
                        <p>机构：{userInfo.orgAccount ? userInfo.orgAccount.orgName : ''}</p>
                        <p>组别：{departments}</p>
                    </dd>
                </dl>
                <a className="password-btn" onClick={this.editPassword}>
                    修改密码
                </a>
            </div>
        );
        return (
            <React.Fragment>
                <header className="header">
                    <nav className="navbar navbar-wrap">
                        <h1 className="logo">
                            <span className="text">一站式保险理赔系统</span>
                        </h1>

                        <div className="navbar-btns">
                            <div className="navbar-marquee" onClick={this.showTaskListModal}>
                                <i className="iconfont icon-xiaoxi" />
                                消息：<span>{this.state.aboutAgent.all}</span>
                            </div>
                            <Suspense fallback={null}>
                                <Calling />
                            </Suspense>
                            <Popover
                                content={profileModal}
                                title={null}
                                overlayClassName="popover-profile"
                                zIndex={900}
                            >
                                <dl className="navbar-profile">
                                    <dd>
                                        <p className="login-name">{userInfo.loginName}</p>
                                        <p className="full-name">{userInfo.fullName}</p>
                                    </dd>
                                </dl>
                            </Popover>
                            <Dropdown overlay={statusList}>
                                <a className={`agent-status ${agentStatus}`}>
                                    <span style={{color: '#816cff'}}>{labelAgentStatus}</span>
                                </a>
                            </Dropdown>
                            <a
                                href="#"
                                className="set_profile"
                                onClick={this.openDialog.bind(this)}
                            >
                                <em>退出</em>
                            </a>
                        </div>
                    </nav>
                </header>
                {this.state.showDialog ? (
                    <Modal
                        title="提示"
                        visible={true}
                        okText={
                            calls.length <= 0
                                ? t('CannedMessages::quit')
                                : t('CannedMessages::acknowledge')
                        }
                        onOk={
                            calls.length <= 0
                                ? this.handleLogout.bind(this)
                                : this.endCallAndLogout.bind(this)
                        }
                        onCancel={this.closeDialog.bind(this)}
                    >
                        <p>
                            {calls.length <= 0
                                ? t('CannedMessages::isQuit')
                                : t('CannedMessages::hasCallOn')}
                        </p>
                    </Modal>
                ) : null}

                <Modal
                    visible={passwordVisible}
                    destroyOnClose
                    title="修改密码"
                    footer={null}
                    onCancel={this.cancelEditPassword}
                    maskClosable={false}
                >
                    <Form
                        ref={this.passwordFormRef}
                        labelCol={{
                            span: 5
                        }}
                        wrapperCol={{
                            span: 16
                        }}
                        autoComplete="off"
                        onFinish={this.handleEditPassword}
                    >
                        <Form.Item
                            label="旧密码"
                            name="oldPassword"
                            rules={[{ required: true, message: '请输入旧密码' }]}
                        >
                            <Input type="password" />
                        </Form.Item>
                        <Form.Item
                            label="新密码"
                            name="newPassword"
                            rules={[{ required: true, message: '请输入新密码' }]}
                        >
                            <Input type="password" />
                        </Form.Item>
                        <Form.Item
                            label="确认密码"
                            name="confirmPassword"
                            rules={[{ required: true, message: '请再次输入新密码' }]}
                        >
                            <Input type="password" />
                        </Form.Item>
                        <Form.Item
                            wrapperCol={{
                                offset: 5,
                                span: 16
                            }}
                            style={{ marginBottom: 0 }}
                        >
                            <Button type="primary" htmlType="submit">
                                保存
                            </Button>
                            <Button onClick={this.cancelEditPassword} style={{ marginLeft: 20 }}>
                                取消
                            </Button>
                        </Form.Item>
                    </Form>
                    {/* <div className="edit-div">
                    <form>
                        <div className="info-div">
                            <label>{t('agentProfile::oldPassword')}</label>
                            <input type="password" value={this.state.oldPassword}
                                onChange={this.onPwdChange.bind(this, 'oldPassword')} placeholder={t('agentProfile::inputPlease')} />
                        </div>
                        <div className="info-div">
                            <label>{t('agentProfile::newPassword')}</label>
                            <input type="password" value={this.state.newPassword}
                                onChange={this.onPwdChange.bind(this, 'newPassword')} placeholder={t('agentProfile::inputPlease')} />
                        </div>
                        <div className="info-div">
                            <label>{t('agentProfile::confirmPassword')}</label>
                            <input type="password" value={this.state.confirmPassword}
                                onChange={this.onPwdChange.bind(this, 'confirmPassword')} placeholder={t('agentProfile::inputPlease')} />
                        </div>
                        <div>
                            <span className="hint">{this.state.resetPwdErrorMsg}</span>
                        </div>
                    </form>
                </div> */}
                    {/* <Modal.Footer>
                    <div className="btn-bottom">
                        <button className="btn1" onClick={this.handleResetPwd.bind(this)}>{t('agentProfile::save')}</button>
                        <button className="btn2" onClick={closeModal}>{t('agentProfile::cancel')}</button>
                    </div>
                </Modal.Footer> */}
                </Modal>

                {this.state.isShowTaskListModal ? (
                    <TaskListModal
                        hideTaskListModal={this.hideTaskListModal}
                        agentId={userInfo._id}
                        handler={
                            userInfo.agentRole &&
                            (userInfo.agentRole.level === '2' || userInfo.agentRole.level === '3')
                                ? ''
                                : userInfo._id
                        }
                        actions={this.props.actions}
                        history={this.props.history}
                        getCoopTaskAboutAgent={this.getCoopTaskAboutAgent}
                        wrappedComponentRef={(TaskListModal) => {
                            this.TaskListModal = TaskListModal;
                        }}
                        currentAgentForTaskListModal={userInfo}
                    />
                ) : null}
            </React.Fragment>
        );
    }
}

/**
 * Props that Header component expects to be passed.
 */
Header.propTypes = {
    // Actions to be dispatched.
    actions: PropTypes.objectOf(PropTypes.func).isRequired,
    // Information related to the logged in agent
    currentAgent: PropTypes.object.isRequired,
    // Dashboard related state
    dashboard: PropTypes.object.isRequired,
    // Session info of the agent agent
    session: PropTypes.object.isRequired
};
let mapStateToProps = (state) => {
    return {
        agents: state.app.agents.list,
        currentAgent: state.app.currentAgent,
        userInfo: state.app.currentAgent.userInfo,
        calls: state.app.kandy.calls,
        customers: state.app.customers.current,
        updateProfileError: state.app.currentAgent.updateProfileError,
        resetPwdError: state.app.currentAgent.resetPwdError,
        company: state.company,
        currentRequest: state.app.customers.current,
        callBy5g: state.callBy5g
    };
};

let mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(
            Object.assign(
                {},
                agentActions,
                dashboardActions,
                serviceRequestActions,
                kandyActions,
                agentProfileActions,
                reportPreviewActions,
                lossAssDashboard,
                report
            ),
            dispatch
        )
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Header));

//export default Header
